import { FC } from 'react';

export type ListItemComponentProps = {
  className?: string;
  value: string;
  nestedItems?: ListItemComponentProps[];
};

const ListItemComponent: FC<ListItemComponentProps> = ({
  className = '',
  value,
  nestedItems,
}) => {
  return (
    <div className='flex flex-col flex-1'>
      <div className={`flex flex-row items-start space-x-8 ${className}`}>
        <div>&bull;</div> <span>{value}</span>
      </div>

      {nestedItems && (
        <div className='ml-10'>
          {nestedItems.map((item, idx) => (
            <ListItemComponent {...item} key={idx} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ListItemComponent;
